import { render, staticRenderFns } from "./RegisterPerson.vue?vue&type=template&id=1cd005a7&"
import script from "./RegisterPerson.vue?vue&type=script&lang=js&"
export * from "./RegisterPerson.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPerson.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports